
var FirebaseConfig = {
  apiKey: "AIzaSyDs0J8vCSCnBF9mgiNpIL4au3sqkKZgcg8",
  authDomain: "app-notification-80f36.firebaseapp.com",
  databaseURL:"https://app-notification-80f36-default-rtdb.firebaseio.com",
  projectId: "app-notification-80f36",
  storageBucket: "app-notification-80f36.appspot.com",
  messagingSenderId: "344189109166",
  appId: "1:344189109166:web:a068483f728e89eed93e3f",
  measurementId: "G-XVXR720SCC"
};

export default FirebaseConfig

